import { MainFastrFooter } from "@components/footers/MainFastrFooter";
import { MainFastrHeader } from "@components/headers/MainFastrHeader";
import {
  WorkflowActionsStickyFooter,
  WorkflowActionsStickyFooterProps,
} from "./WorkflowActionsStickyFooter";
import { Box } from "@mui/material";
import React from "react";

type PageLayoutProps = {
  children: React.ReactNode;
} & WorkflowActionsStickyFooterProps;

export default function PageLayout({
  children,
  ...WorkflowActionsStickyFooterProps
}: PageLayoutProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <MainFastrHeader />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "24px",
          gap: "24px",
          alignSelf: "stretch",
        }}
      >
        {children}
      </Box>
      <WorkflowActionsStickyFooter {...WorkflowActionsStickyFooterProps} />
      <MainFastrFooter />
    </Box>
  );
}
